<!-- @format -->

<div
  class="hmf-display-flex hmf-flex-wrap image-viewer-container"
	[ngClass]="{
		'out-of-stock-image-container':
			!alternativeInStockRecsEnabled && shouldShowOutOfStockRecs === true,
		'pl-image-container': shouldHaveBorder,
		'move-to-top': imageBadge && chainIdentifierAbbr !== 'calia'
	}">
  @if (simpleImageViewer || showHeroImage || imageUnavailable) {
    <div
      class="image-container hmf-col hmf-span-12"
      >
      <!-- Hero image -->
      <div
        class="image-viewer-hero-container"
			[ngClass]="{
				'out-of-stock-image-viewer-hero-container':
					!alternativeInStockRecsEnabled && shouldShowOutOfStockRecs === true,
				disabled: imageViewerDisabled
			}">
        <!-- Badge -->
        @if (imageBadge) {
          <hmf-badge
            class="image-badge badge-overlay no-left"
            [badgeName]="imageBadge" />
        }
        @if (!imageUnavailable) {
          <div
				[ngClass]="{
					'image-viewer-single': mediaSetItems?.length === 1,
					'video-cover': heroImage.type === 'video',
					'pl-image': shouldHaveBorder
				}"
            (keypress)="onFullScreenTargetClick(heroImage?.index)"
            (click)="onFullScreenTargetClick(heroImage?.index)"
            tabindex="0"
            role="button"
            [id]="'image-viewer-hero-wrapper-' + eCode"
            class="image-viewer-wrapper-grid image-viewer-hero-wrapper hmf-display-flex hmf-flex-row hmf-align-items-center hmf-justify-content-center hmf-mb-m hmf-py-m hmf-px-xs">
            <div class="hmf-display-block">
              <pdp-product-image
                [mediaSetItemType]="mediaSetItem?.type"
                [killSwitches]="killSwitches"
                [chainIdentifierAbbr]="chainIdentifierAbbr"
                [pictureSources]="getHeroImagePictureSources()">
                <div
                  fallback-image
                  class="hmf-position-relative">
                  <hmf-product-image
                    [ecode]="product?.partNumber"
                    [imageData]="heroImageProductImageData"
                    [productName]="productName"
                    [selectedSwatchColor]="swatchColor"
                  (imageErrorDetected)="handleImageError()"></hmf-product-image>
                </div>
              </pdp-product-image>
            </div>
          </div>
        }
        @if (!simpleImageViewer) {
          <div
            tabindex="0"
            role="button"
            aria-label="View Image in Full Screen"
            class="full-screen-icon"
            (keypress)="onFullScreenTargetClick(heroImage?.index)"
            (click)="onFullScreenTargetClick(heroImage?.index)">
            <homefield-icon
              width="24px"
              height="24px"
              alt="View Full Screen"
            name="zoom-image"></homefield-icon>
          </div>
        }
        @if (!available) {
          <div
            class="out-of-stock-box hmf-display-flex hmf-flex-column hmf-flex-justify-content-center">
            <div class="out-of-stock-box-text">Out of Stock</div>
          </div>
        }
      </div>
      <!-- image unavailable -->
      @if (imageUnavailable) {
        <div
          [id]="'image-viewer-hero-wrapper-' + eCode"
          class="image-viewer-hero-wrapper hmf-display-flex hmf-flex-row hmf-align-items-center hmf-justify-content-center dcsg-card">
          <picture class="hmf-display-flex hmf-align-items-center hmf-justify-content-center">
            <source
              media="(min-width: 1200px)"
              type="image/webp"
              [srcset]="heroImage.poster + '?qlt=70&wid=640&fmt=webp&op_sharpen=1'" />
            <source
              media="(min-width: 1200px)"
              [srcset]="heroImage.poster + '?qlt=70&wid=640&fmt=pjpeg&op_sharpen=1'" />
            <source
              media="(min-width: 768px)"
              type="image/webp"
              [srcset]="heroImage.poster + '?qlt=70&wid=400&fmt=webp&op_sharpen=1'" />
            <source
              media="(min-width: 768px)"
              [srcset]="heroImage.poster + '?qlt=70&wid=400&fmt=pjpeg&op_sharpen=1'" />
            <source
              type="image/webp"
              [srcset]="heroImage.poster + '?qlt=70&wid=350&fmt=webp&op_sharpen=1'" />
            <img
              class="gallery-image"
              [ngSrc]="heroImage.poster + '?qlt=70&wid=350&fmt=pjpeg&op_sharpen=1'"
              [alt]="productName + ' product'"
              itemprop="image"
              loading="lazy"
              [width]="350"
              [height]="350" />
          </picture>
        </div>
      }
      @if (shouldShowOutOfStockRecs && !alternativeInStockRecsEnabled) {
        <div
          class="out-of-stock-recommendations-box hmf-display-flex hmf-flex-column hmf-justify-content-center"
          >
          <div class="out-of-stock-box-text">OPTION NOT AVAILABLE</div>
          @if (nearbyStoreCount > 0 && !doesCurrentlySetStoreHaveInventory) {
            <div
              class="available-stores-out-of-stock-box-text">
              Available at
              <span class="number-of-available-stores-text"> {{ nearbyStoreCount }} </span>nearby
              stores within 100 miles
            </div>
          }
          @if (nearbyStoreCount > 0 && !doesCurrentlySetStoreHaveInventory) {
            <a
              class="change-store-out-of-stock-box-link"
              (click)="toggleStoreLayerSideNav()"
              >Change Store</a
              >
            }
          </div>
        }
      </div>
    }

    <!-- Alt images -->
    @if (
      mediaSetItems?.length > altImageIndexStart &&
      !simpleImageViewer &&
      ((!shouldShowOutOfStockRecs && !alternativeInStockRecsEnabled) ||
      alternativeInStockRecsEnabled) &&
      !showHeroImage
      ) {
      <div
        class="hmf-span-12"
        >
        <!-- Badge -->
        @if (imageBadge) {
          <hmf-badge
            class="image-badge badge-overlay"
            [badgeName]="imageBadge" />
        }
        <div class="hmf-display-flex hmf-flex-wrap gap-s">
          @for (
            mediaSetItem of mediaSetItems
            | slice: altImageIndexStart : altImageIndexEnd; track trackByFn(mediaSetItemIndex,
            mediaSetItem); let mediaSetItemIndex = $index; let isLast = $last) {
            <div
              [ngClass]="{ 'smaller-alt-image': smallerAltImages }"
              class="image-viewer-swatch-col hmf-span-3">
              <button
                [id]="'alt-image-viewer-wrapper-' + eCode"
                aria-label="View Image in Full Screen"
                class="image-wrapper-padding image-wrapper-height hmf-p-xs-xl image-viewer-swatch-wrapper hmf-position-relative"
                (click)="onFullScreenTargetClick(mediaSetItemIndex + altImageIndexStart)"
					[ngClass]="{
						'dcsg-card': !isImageGalleryZoomEnabled(),
						'video-cover': mediaSetItem.type === 'video',
						'image-viewer-swatch-col-last': isLast,
						'pl-image': shouldHaveBorder,
						'smaller-alt-image-wrapper': smallerAltImages
					}">
                <div class="hmf-display-flex hmf-align-items-center hmf-justify-content-center">
                  @if (mediaSetItem?.templateSrc === defaultImage) {
                    <pdp-product-image
                      [disableZoom]="true"
                      [killSwitches]="killSwitches"
                      [chainIdentifierAbbr]="chainIdentifierAbbr"
                      [mediaSetItemType]="mediaSetItem?.type">
                      <img
                        fallback-image
                        class="img-fluid hmf-position-absolute"
                        [src]="mediaSetItem?.templateSrc"
                        [alt]="productName + ' product'"
                        itemprop="image"
                        loading="lazy" />
                    </pdp-product-image>
                  } @else {
                    <pdp-product-image
                      [killSwitches]="killSwitches"
                      [mediaSetItemType]="mediaSetItem?.type"
                      [chainIdentifierAbbr]="chainIdentifierAbbr"
                      [pictureSources]="getMediaSetPictureSources(mediaSetItem)">
                      <img
                        fallback-image
                        class="img-fluid hmf-position-absolute"
									[src]="
										(mediaSetItem?.templateSrc || mediaSetItem?.poster) +
										'?qlt=70&wid=780&hei=780&fmt=pjpeg&op_sharpen=1&fit=constrain'
									"
                        [alt]="productName + ' product'"
                        itemprop="image"
                        loading="lazy"
									(error)="
										handleAltImageError(mediaSetItemIndex + altImageIndexStart)
									" />
                    </pdp-product-image>
                  }
                </div>
              </button>
            </div>
          }
        </div>
      </div>
    }
    <!-- View More button -->
    @if (mediaSetItems?.length > 0) {
      <div
        class="hmf-col hmf-span-12 view-more-button hmf-mt-s hmf-mb-md-l"
        >
        <div class="hmf-display-flex hmf-flex-wrap">
          <div class="hmf-mx-auto">
            @if (simpleImageViewer) {
              <button
                aria-label="View All {{ mediaSetItemCount }} Images"
                hmf-button
                variant="tertiary"
                class="hmf-my-xs"
                (keypress)="onFullScreenTargetClick(0)"
                (click)="onFullScreenTargetClick(0)"
              text="View All {{ mediaSetItemCount }} Images"></button>
            }
            @if (!simpleImageViewer && mediaSetItemCount > 4) {
              <button
                hmf-button
                variant="secondary"
					[attr.aria-label]="
						expanded ? 'View all ' + mediaSetItemCount + ' images' : 'View less'
					"
					text="{{
						expanded ? 'View All ' + mediaSetItemCount + ' Images' : 'View Less'
					}}"
                icon="{{ expanded ? 'chevron-down' : 'chevron-up' }}"
                (keypress)="onExpandAllClick()"
              (click)="onExpandAllClick()"></button>
            }
          </div>
          @if (isJumpLinkEnabled() && styliticsWidgetShown()) {
            <div class="jumplink-container hmf-display-flex hmf-justify-content-center">
              <pdp-component-stylitics-jumplink
              [isMobile]="false"></pdp-component-stylitics-jumplink>
            </div>
          }
        </div>
      </div>
    }
  </div>
